// export const baseURL = "http://localhost:3800/";
// export const baseDomain = "localhost";
//  export const baseURL = "https://testing658923abcfed.nearlaw.com/";
 export const baseURL = "https://nearlaw.com/";
 export const baseDomain = ".nearlaw.com";
//  export const baseDomain = "testing.nearlaw.com";
